import React from "react";
import SearchBar from "../../features/SearchBar";

function Header() {
  return (
    <div>
      <header className="header">
        <div className="headerFlex">
          <img src="redditLogo1.png" alt="Reddit Logo" />
          <p>
            <span className="reddit">Reddit</span>
            <span className="minimal">Minimal</span>
          </p>

          <SearchBar className="searchBar" />
        </div>
      </header>
    </div>
  );
}

export default Header;
